import React from 'react';
import { t } from 'ttag';


class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderFooter: false
    };
  }

  componentDidMount() {
    this.setState({
      renderFooter: !window.location.pathname.startsWith('/jegy/client'),
    }, () => {
    if(!this.state.renderHeader) {
      // document.body.style.paddingTop = "0px";
      }
    });
  }

  render() {
    return (
      this.state.renderFooter ? (
      <div className="footer footer--dark" id="sticky-footer" style={{ padding: '20px 0' }}>
        <div className="container">
          <div className="footer__inner">
            <a href="https://www.jegyezz.hu/" className="footer__textLogo">Jegyezz.hu</a>
            <div className="footer__data">
              <div className="footer__data__item">
                <div className="footer__row">
                  <a href="https://zszportal.zalaszam.hu" className="footer__link">Copyright 2019 © Zalaszám Informatika Kft.</a>
                </div>
                <div className="footer__row">
                  <a href="https://www.jegyezz.hu/" className="footer__link">info@zalaszam.hu</a>
                </div>
              </div>
              <div className="footer__data__item">
                {/* Később kell visszarakni, amikor ki lett alakítva a statikus oldal, vagy más megoldás  */}
                {/* <div className="footer__row"><Link to="/jegy/aszf" className="footer__link">{ t`ÁSZF` }</Link>
                </div>
                <div className="footer__row"><Link to="/jegy/adatvedelmi" className="footer__link">{ t`Adatvédelmi és jogi nyilatkozat` }</Link>
                </div> */}
                <div className="footer__row"><a href="https://www.jegyezz.hu/" className="footer__link">{ t`Kapcsolat` }</a>
                </div>
              </div>
              <div className="footer__data__item">
                <div className="footer__row">
                  <a href="https://www.facebook.com/zalaszam" className="footer__link">Facebook</a>
                </div>
                <div className="footer__row">
                  <a href="https://www.linkedin.com/company/zalaszám-it-consulting/about/" className="footer__link">LinkedIn</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ) : null
    );
  };
};

export default Footer;